import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import i18n from '../../utils/i18n'

export const CurrencyFilterTemplate = (options: any) => {
  if (!options) return null

  const currencies = [
    { name: 'EUR (Euro)', code: 'EUR' },
    { name: 'USD (US dollar)', code: 'USD' },
  ]

  return (
    <Dropdown
      value={options.value}
      options={currencies}
      optionLabel="name"
      optionValue="code"
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchCurrency')}
      filter
    />
  )
}
